



































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { Route } from "vue-router";
// types
import { InstanceGroup, Instance, InstanceGroupDto } from "@/services/instances/types";
// service methods
import {
    createInstanceGroup,
    getInstanceGroupById,
    updateInstanceGroup
} from "@/services/instances/instanceGroupService";
// components
import InstanceGroupDetails from "@/components/instances/InstanceGroupDetails.vue";
import InstanceGroupInstances from "@/components/instances/InstanceGroupInstances.vue";
import HeaderActionButtons from "@/components/layouts/HeaderActionButtons.vue";

@Component({
    components: {
        InstanceGroupDetails,
        InstanceGroupInstances,
        HeaderActionButtons
    }
})
export default class InstanceGroupForm extends Vue {
    @Prop() private groupId!: string;
    @Prop() private groupName!: string;

    // local state
    group = {} as InstanceGroupDto;
    componentsData = [
        {
            componentName: "InstanceGroupDetails",
            order: 0,
            collapseState: true
        },
        {
            componentName: "InstanceGroupInstances",
            order: 1,
            collapseState: true
        }];

    formState = false;
    valid = false;

    // lifecycle hooks
    public created() {
        this.fetchData();
    }

    // Watcher
    firstTime = true as boolean;
    @Watch("$route", { immediate: true, deep: true })
    onUrlChange(newVal: any) {
        if (this.firstTime) {
            this.firstTime = false;
        } else {
            this.fetchData();
        }
    }

    // Computed
    get instanceGroupDetails(): any {
        return {
            name: this.group.name,
            description: this.group.description
        } as InstanceGroup;
    }

    get components() {
        return this.componentsData;
    }

    get editMode() {
        return !!this.groupId;
    }

    onDetailsUpdated(details: InstanceGroup) {
        this.group.name = details.name || "";
        this.group.description = details.description || "";
    }

    onInstancesUpdated(instances: string[]) {
        if (!this.group.instanceIds) {
            this.group.instanceIds = [] as string[];
        }

        this.group.instanceIds = this.group
            .instanceIds
            .concat(instances.filter(u => !this.group.instanceIds.includes(u)));
    }

    onDetailsValid(data: boolean) {
        this.valid = data;
    }

    save() {
        this.childComponentsHandler();
        if (!this.valid) return;
        if (!this.editMode) {
            createInstanceGroup(this.group).then(() => {
                this.$router.push("/InstanceGroups");
            });
        } else {
            updateInstanceGroup(this.group).then(() => {
                this.$router.push("/InstanceGroups");
            });
        }
    }

    fetchData() {
        if (this.editMode) {
            getInstanceGroupById(this.groupId).then(response => {
                this.group = response;
            });
        }
    }

    childComponentsHandler() {
        const validators = [] as any[];
        const components = this.$refs.childComponent as any[];
        components.forEach(component => {
            if (component.validators) { validators.push(component.validators); }
            component.emitData();
            if (!component.isFormValid) return;
            component.isFormValid();
        });
    }

    back() {
        this.$router.push("/InstanceGroups");
    }
}
